import { toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "flex flex-col" }
const _hoisted_2 = { class: "mt-8" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("br", null, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ExternalLink = _resolveComponent("ExternalLink")!
  const _component_Heading = _resolveComponent("Heading")!
  const _component_Anchor = _resolveComponent("Anchor")!
  const _component_Picture = _resolveComponent("Picture")!
  const _component_Paragraph = _resolveComponent("Paragraph")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_Anchor, {
      external: "",
      route: _ctx.url
    }, {
      default: _withCtx(() => [
        _createVNode(_component_Heading, {
          tag: "h2",
          purple: "",
          "no-margin": ""
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.title) + " ", 1),
            _createVNode(_component_ExternalLink, { class: "inline ml-2 share__external lg:ml-3" })
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["route"]),
    _createVNode(_component_Anchor, {
      external: "",
      route: _ctx.url,
      bold: false
    }, {
      default: _withCtx(() => [
        _createTextVNode(_toDisplayString(_ctx.url), 1)
      ]),
      _: 1
    }, 8, ["route"]),
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_Anchor, {
        route: _ctx.url,
        external: ""
      }, {
        default: _withCtx(() => [
          (_ctx.image.length)
            ? (_openBlock(), _createBlock(_component_Picture, {
                key: 0,
                image: _ctx.image[0],
                height: _ctx.image ? '100%' : '400px',
                width: "100%",
                cover: ""
              }, null, 8, ["image", "height"]))
            : _createCommentVNode("", true)
        ]),
        _: 1
      }, 8, ["route"])
    ]),
    _createVNode(_component_Paragraph, {
      class: "mt-12",
      innerHTML: _ctx.content
    }, null, 8, ["innerHTML"]),
    _createVNode(_component_Paragraph, { class: "font-bold" }, {
      default: _withCtx(() => [
        _createTextVNode(_toDisplayString(_ctx.isCNLocale ? `来自 ${ _ctx.name } 的分享` : `Shared by ${ _ctx.name }`) + " ", 1),
        _hoisted_3,
        _createTextVNode(" " + _toDisplayString(_ctx.role), 1)
      ]),
      _: 1
    })
  ]))
}